<template>
  <div>
    <div v-if="isAuth">
      <router-view></router-view>
    </div>
    <Modal
      :is-show="isShowModal"
      :is-show-cancel="expired ? false : true"
      :is-back-clickable="expired ? false : true"
      :accept-text="expired ? 'Okay' : $t('accountPage.acceptCloseSession')"
      :cancel-text="$t('accountPage.cancelCloseSession')"
      size="sm"
      v-on:close="isShowModal = false"
      v-on:accept="isShowModal = false"
      ref="confirm-modal"
    >
      <div class="px-3 pt-4">
        <span class="lead d-block text-center">{{ modalText }}</span>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      isShowModal: false,
      resolve: null,
      expired: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuth', 'sessionStatus']),
    modalText() {
      return this.expired
        ? this.$t('exitModalExpiredText')
        : this.$t('exitModalText')
    }
  },
  beforeRouteLeave(to, from, next) {
    if (from.query.expired) {
      this.expired = true
    }
    this.showConfirmModal(next)
  },
  methods: {
    ...mapActions('auth', ['closeSession']),
    ...mapActions('personal', ['wipeAllData']),
    showConfirmModal(nextCallback) {
      this.isShowModal = true
      const modal = this.$refs['confirm-modal']
      modal.confirm().then(result => {
        if (result) {
          if (this.expired) {
            this.wipeAllData()
          } else {
            this.closeSession().then(() => { this.wipeAllData() })
          }
          nextCallback()
        } else {
          nextCallback(false)
        }
      })
    }
  }
}
</script>
